import React, { useState } from 'react';
import Logo from '../../static/images/halg_logo.png'
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

function Navbar({ title = 'Heartland Alliance LTD/GTE' }) {

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { pathname } = useLocation();
    const isAdminPage = pathname && pathname.startsWith('/admin');
    const isLoginPage = pathname === '/users/login';
    const logoTarget = (isAdminPage || isLoginPage) ? '/admin/orders/lookup' : '/';

    const handleMenuToggle = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <nav className='navbar shadow-sm text-neutral-content mx-auto w-full'>
            <div className='container mx-auto flex items-center justify-between'>
                <div className='flex-none px-2 mx-2 mx-2'> 
                    <Link to={logoTarget} className='text-lg font-bold align-middle'>
                        <img className="inline max-w-xs max-h-10 sm:max-h-12" src={Logo} alt="Heartland Alliance LTD/GTE" /> 
                    </Link>
                </div>

                <div className="flex items-center" style={{ fontFamily: "Impact, sans-serif" }}>
                    {/* Desktop menu links */}
                    <div className={`hidden md:flex md:items-center md:space-x-4`}>
                        <Link to="/" className="btn font-bold btn-ghost text-teal-900 btn-sm rounded-btn hover:bg-transparent text-xl sm:text-4xl"> Home </Link>
                        <Link to="/about" className="btn font-bold btn-ghost text-teal-900 btn-sm rounded-btn hover:bg-transparent text-xl sm:text-4xl"> About </Link>
                        <Link to="/faq" className="btn font-bold btn-ghost text-teal-900 btn-sm rounded-btn hover:bg-transparent text-xl sm:text-4xl"> FAQ </Link>
                    </div>

                    <button 
                        onClick={handleMenuToggle} 
                        className={`hamburger inline-flex flex-col justify-around items-center p-2 w-10 h-10 md:hidden ${isMenuOpen ? 'is-active' : ''}`} 
                        aria-controls="navbar-default" 
                        aria-expanded={isMenuOpen ? 'true' : 'false'}
                    >
                        <span className="line1 block w-6 h-0.5 bg-gray-800 transition-all duration-300"></span>
                        <span className="line2 block w-6 h-0.5 bg-gray-800 transition-all duration-300"></span>
                        <span className="line3 block w-6 h-0.5 bg-gray-800 transition-all duration-300"></span>
          
                    </button>
                </div>
            </div>

            <div className={`md:hidden ${isMenuOpen ? 'block' : 'hidden'} z-50 h-full`}>
                <div className="flex text-white flex-col space-y-4 p-4 shadow-lg bg-teal-900">
                    <Link to="/" className="btn font-bold btn-ghost btn-sm rounded-btn hover:bg-transparent text-lg" onClick={() => setIsMenuOpen(false)}> Home </Link>
                    <Link to="/about" className="btn font-bold btn-ghost  btn-sm rounded-btn hover:bg-transparent text-lg" onClick={() => setIsMenuOpen(false)}> About </Link>
                    <Link to="/faq" className="btn font-bold btn-ghost btn-sm rounded-btn hover:bg-transparent text-lg" onClick={() => setIsMenuOpen(false)}> FAQ </Link>
                </div>
            </div>
        </nav>
    )
}


Navbar.propTypes = {
    title: PropTypes.string,
}

export default Navbar
